module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%- namespace %> { <%- header_display.toLowerCase()==='false'? 'display: none;' : '' %> } <%- namespace %> .main-title { <%- main_title_color.length>0? 'color: '+main_title_color+';' : '' %> } <%- namespace %> .wrapper-brand-text h2 { <%- brand_text_color.length>0? 'color: '+brand_text_color+';' : '' %> } <%- namespace %> .ad-sponsor .sponsored small { <%- sponsored_text_color.length>0? 'color: '+sponsored_text_color+';' : '' %> } <%- namespace %> .wrapper-share-buttons span { <%- share_text_color.length>0? 'color: '+share_text_color+';' : '' %> } <% if(white_share_icons === \"true\"){ %> <%- namespace %> .wrapper-share-buttons .share-btn .icon-twitter-btn svg path, <%- namespace %> .wrapper-share-buttons .share-btn .icon-facebook-btn svg path { fill: #FFF; } <%- namespace %> .header-bottom .wrapper-share-buttons .share-btn { background: transparent; } <% } %> <%- namespace %> .wrapper-upload-content .btn-link span { <%- upload_text_color.length>0? 'color: '+upload_text_color+';' : '' %> } <%- namespace %>.view-header .wrapper-upload-content .btn-link div[class^=\"icon-\"] svg { <%- upload_text_color.length>0? 'fill: '+upload_text_color+';' : '' %> } <%- namespace %> .view-filter { <%- filters.display.toLowerCase()==='false'? 'display: none;' : '' %> } <%- namespace %> .view-filter .filter-btn { <%- filters.selected_text_color.length>0? 'background-color: '+filters.selected_text_color+';' : '' %> <%- filters.selected_background_color.length>0? 'color: '+filters.selected_background_color+';' : '' %> <%- filters.selected_background_color.length>0? 'border-color: '+filters.selected_background_color+';' : '' %> } <%- namespace %> .view-filter .filter-btn div[class^=\"icon-\"] svg { <%- filters.selected_background_color.length>0? 'fill: '+filters.selected_background_color+';' : '' %> } <%- namespace %> .view-filter .filter-btn.active { <%- filters.selected_text_color.length>0? 'color: '+filters.selected_text_color+';' : '' %> <%- filters.selected_background_color.length>0? 'background-color: '+filters.selected_background_color+';' : '' %> } <%- namespace %> .view-filter .filter-btn.active div[class^=\"icon-\"] svg { <%- filters.selected_text_color.length>0? 'fill: '+filters.selected_text_color+';' : '' %> } <% if(!bg.useBgAsImage) { %> <%- namespace %> .header-context .header-subject { <%- bg.image.length>0 ? 'background-image: url(\"'+bg.image+'\");' : 'none' %> <%- bg.image_size.length>0 ? 'background-size: '+bg.image_size+';' : 'none' %> <%- bg.image_repeat.length>0 ? 'background-repeat: '+bg.image_repeat+';' : 'none' %> <%- bg.image_position.length>0 ? 'background-position: '+bg.image_position+';' : 'none' %> } <% } %> <% if(typeof bg.image_mobile != \"undefined\"){ %> @media (max-width: 480px) { <% if(!bg.useBgAsImage) { %> <%- namespace %> .header-context .header-subject { <%- bg.image_mobile.length>0 ? 'background-image: url(\"'+bg.image_mobile+'\");' : 'none' %> } <% } %> } <% } %> "
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append( namespace )
    ; __append(" { ")
    ; __append( header_display.toLowerCase()==='false'? 'display: none;' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .main-title { ")
    ; __append( main_title_color.length>0? 'color: '+main_title_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .wrapper-brand-text h2 { ")
    ; __append( brand_text_color.length>0? 'color: '+brand_text_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .ad-sponsor .sponsored small { ")
    ; __append( sponsored_text_color.length>0? 'color: '+sponsored_text_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .wrapper-share-buttons span { ")
    ; __append( share_text_color.length>0? 'color: '+share_text_color+';' : '' )
    ; __append(" } ")
    ;  if(white_share_icons === "true"){ 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .wrapper-share-buttons .share-btn .icon-twitter-btn svg path, ")
    ; __append( namespace )
    ; __append(" .wrapper-share-buttons .share-btn .icon-facebook-btn svg path { fill: #FFF; } ")
    ; __append( namespace )
    ; __append(" .header-bottom .wrapper-share-buttons .share-btn { background: transparent; } ")
    ;  } 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .wrapper-upload-content .btn-link span { ")
    ; __append( upload_text_color.length>0? 'color: '+upload_text_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(".view-header .wrapper-upload-content .btn-link div[class^=\"icon-\"] svg { ")
    ; __append( upload_text_color.length>0? 'fill: '+upload_text_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .view-filter { ")
    ; __append( filters.display.toLowerCase()==='false'? 'display: none;' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .view-filter .filter-btn { ")
    ; __append( filters.selected_text_color.length>0? 'background-color: '+filters.selected_text_color+';' : '' )
    ; __append(" ")
    ; __append( filters.selected_background_color.length>0? 'color: '+filters.selected_background_color+';' : '' )
    ; __append(" ")
    ; __append( filters.selected_background_color.length>0? 'border-color: '+filters.selected_background_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .view-filter .filter-btn div[class^=\"icon-\"] svg { ")
    ; __append( filters.selected_background_color.length>0? 'fill: '+filters.selected_background_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .view-filter .filter-btn.active { ")
    ; __append( filters.selected_text_color.length>0? 'color: '+filters.selected_text_color+';' : '' )
    ; __append(" ")
    ; __append( filters.selected_background_color.length>0? 'background-color: '+filters.selected_background_color+';' : '' )
    ; __append(" } ")
    ; __append( namespace )
    ; __append(" .view-filter .filter-btn.active div[class^=\"icon-\"] svg { ")
    ; __append( filters.selected_text_color.length>0? 'fill: '+filters.selected_text_color+';' : '' )
    ; __append(" } ")
    ;  if(!bg.useBgAsImage) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .header-context .header-subject { ")
    ; __append( bg.image.length>0 ? 'background-image: url("'+bg.image+'");' : 'none' )
    ; __append(" ")
    ; __append( bg.image_size.length>0 ? 'background-size: '+bg.image_size+';' : 'none' )
    ; __append(" ")
    ; __append( bg.image_repeat.length>0 ? 'background-repeat: '+bg.image_repeat+';' : 'none' )
    ; __append(" ")
    ; __append( bg.image_position.length>0 ? 'background-position: '+bg.image_position+';' : 'none' )
    ; __append(" } ")
    ;  } 
    ; __append(" ")
    ;  if(typeof bg.image_mobile != "undefined"){ 
    ; __append(" @media (max-width: 480px) { ")
    ;  if(!bg.useBgAsImage) { 
    ; __append(" ")
    ; __append( namespace )
    ; __append(" .header-context .header-subject { ")
    ; __append( bg.image_mobile.length>0 ? 'background-image: url("'+bg.image_mobile+'");' : 'none' )
    ; __append(" } ")
    ;  } 
    ; __append(" } ")
    ;  } 
    ; __append(" ")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}